import React from "react";

import { IBaseCard } from "./interface";
import { Container } from "./styles";

export const BaseCard: React.FC<IBaseCard> = ({
  id,
  children,
  onClick,
  selected,
  height,
  disabled,
  background,
  isLog,
  ...props
}) => {
  return (
    <Container
      id={id}
      height={height}
      onClick={onClick}
      selected={selected}
      disabled={disabled}
      background={background}
      isLog={isLog}
      {...props}
    >
      {children}
    </Container>
  );
};
